"use client"


type Props = {
    path: string
}

export function HreflangTags({ path }: Props) {
    // Normalize path (ensure it starts with / and doesn't have locale prefix)
    const cleanPath = path.startsWith('/') ? path : `/${path}`
    const baseUrl = 'https://zentjes.app'

    return (
        <>
            <link
                rel="alternate"
                href={`${baseUrl}${cleanPath}`}
                hrefLang="en"
            />
            <link
                rel="alternate"
                href={`${baseUrl}/nl${cleanPath}`}
                hrefLang="nl"
            />
            <link
                rel="alternate"
                href={`${baseUrl}${cleanPath}`}
                hrefLang="x-default"
            />
        </>
    )
}
